import React from "react";

export const PillarCard = ({ pillar, idx }) => (
  <div
    data-testid={`methodology-pillar-card-${idx}`}
    className="rounded-2xl bg-[#FDFAF3] border-2 border-orange-300 hover:border-orange-500 transition-all duration-300 shadow-sm hover:shadow-md overflow-hidden group flex flex-col"
  >
    {pillar.image_url && (
      <div className={`relative h-40 overflow-hidden ${pillar.image_fit === "contain" ? "bg-[#0B132B]" : ""}`} data-testid={`methodology-pillar-photo-${idx}`}>
        <img src={pillar.image_url} alt={pillar.image_caption || pillar.title} width="400" height="160" loading="lazy" decoding="async" className={`w-full h-full ${pillar.image_fit === "contain" ? "object-contain py-2" : "object-cover object-[10%_15%]"} transition-transform duration-500 group-hover:scale-105`} />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#071E54]/95 via-[#071E54]/70 to-transparent px-4 pt-10 pb-3">
          <p className="text-xs font-bold text-amber-200 tracking-wide leading-snug text-left">{pillar.image_caption}</p>
        </div>
      </div>
    )}
    <div className="p-6 space-y-3 flex-1">
      <div className="flex items-center justify-between">
        <span className="text-2xl font-black text-[#003399]">{pillar.number}</span>
        <span className="px-2.5 py-0.5 rounded-full bg-blue-50 text-[#003399] text-xs font-bold border border-blue-100">{pillar.stat} {pillar.stat_label}</span>
      </div>
      <h3 className="text-base font-black text-[#071E54]">{pillar.title}</h3>
      <p className="text-xs font-bold text-amber-700">{pillar.tagline}</p>
      <p className="text-xs leading-relaxed text-gray-600 font-medium">{pillar.description}</p>
    </div>
  </div>
);
